module.exports = __webpack_public_path__ + "static/img/stefan-stefancik-257625-unsplash.9ae1d69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/stefan-stefancik-257625-unsplash.jpg
// module id = 67ML
// module chunks = 1